import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceProviderService } from '../../Service/Service-providers/service-provider.service';

@Component({
  selector: 'app-under-construction',
  templateUrl: './under-construction.component.html',
  styleUrls: ['./under-construction.component.scss'],
})
export class UnderConstructionComponent {
  constructor(private authService: ServiceProviderService, private router: Router) { }

  logout() {
    this.authService.logout(); // Clear localStorage and other auth data
    this.router.navigate(['/login']); // Redirect to login page
  }
}
